
import React, { useState } from 'react';
import { IonButton, IonIcon, IonItem, IonList, IonPopover, IonContent } from '@ionic/react';
import { Country, getFlagForCountry } from '../utils/Regions';
import { useCountry } from '../utils/Settings';
import './CountrySelector.css';
import { chevronDownOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { useGA4React } from 'ga-4-react';

const CountrySelector: React.FC = () => {
    const [t] = useTranslation();
    const [popoverState, setPopoverState] = useState({ show: false, event: undefined });
    const [country, setCountry] = useCountry();
    const ga = useGA4React();

    const onCountrySelected = (country: Country) => {
        if (ga)
            ga.event("countrySelect", "country", country.toString());

        setCountry(country);
        setPopoverState({ show: false, event: undefined });
    };

    const selectedCountryFlag = getFlagForCountry(country);

    return (<>
        <IonButton
            className="countryButton"
            fill="outline"
            size="large"
            shape="round"
            onClick={(e: any) => {
                e.persist();
                setPopoverState({ show: true, event: e })
            }}>
            <div>{t(country)}</div>
            <IonIcon src={selectedCountryFlag} slot="end" />
            <IonIcon src={chevronDownOutline} slot="end" />
        </IonButton>
        <IonPopover
    isOpen={popoverState.show}
    event={popoverState.event}
    onDidDismiss={() => setPopoverState({ show: false, event: undefined })}
>
            <IonContent>
                <IonList>
                    {
                        Object
                            .values(Country)
                            .map((value: Country) => {
                                return (
                                    <IonItem
                                        button
                                        key={value}
                                        onClick={() => onCountrySelected(value)}
                                    >
                                        <IonIcon icon={getFlagForCountry(value)} slot="end" />
                                        {t(value)}
                                    </IonItem>
                                );
                            })
                    }
                </IonList>
            </IonContent>
        </IonPopover>

    </>
    );
};

export default CountrySelector;